import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CoreService, HttpService } from '../services';
import { HttpClient, } from '@angular/common/http';
import { ToastService } from '../toast';
import { Router } from '@angular/router';
import { TagModel } from '../models/tag';
import { DialogService } from '../dialog';
import { Select } from '../models';

@Component({
  selector: 'q-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css'],
})

export class TagComponent implements OnInit {

  @Input('relation')
  set relation(value: string) {
    this.tagModel.relation = value;
  }

  @Input('idPere')
  set idPere(value: string | number) {

    if (typeof (value) === 'number') {
      value = value.toString();
    }

    this.tagModel.idPere = value;
    this.init();
  }

  @Input('tagList')
  set tagList(value: Array<string>) {
    this.tagModel.tags = value; 
  }




  @Output() SearchMode: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
  @Output() SearchTagSelect: EventEmitter<Array<Select>> = new EventEmitter<Array<Select>>();


  tagModel: TagModel = new TagModel();
  filteredTag: Array<string> = new Array<string>();
  tag: string;
  arrowSelectedTag: string;
  isSearchMode: boolean;

  placeholder: string;

  @ViewChild('tagTyper') tagTyper: ElementRef;
  @ViewChild('autoSuggest') autoSuggest: ElementRef;
  @ViewChildren('tagAutoSuggest') tagAutoSuggest: QueryList<ElementRef>;


  constructor(
    protected sanitize: DomSanitizer,
    protected indParam: CoreService,
    protected http: HttpClient,
    protected toast: ToastService,
    protected router: Router,
    protected service: HttpService,
    protected dialogservice: DialogService,
    protected renderer: Renderer2,) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setAutoSuggestSize();
  }

  ngOnInit(): void {
    this.isSearchMode = this.SearchMode.observers.length > 0 || this.SearchTagSelect.observers.length > 0;
    this.placeholder = this.isSearchMode ? 'Rechercher un tag...' : 'Ajouter un tag...';

    if (!this.tagModel.idPere) {
      this.init();
    }
  }


  public init() {
    if (this.tagModel.idPere && this.tagModel.relation) {
      this.tagModel.Mode = 'GET_TAG';
      this.service.postHttp<TagModel>(`${this.indParam.AppParams.apiUrl}api/tag/`, this.tagModel).subscribe((data: TagModel) => {
        this.dialogservice.showSplash(false);
        this.tagModel = data;
        this.filteredTag = data.filteredTag;
        //this.getAllTag();
        this.setAutoSuggestSize();
      });
    } else {
      this.getAllTag();
      this.setAutoSuggestSize();
    }
  }

  public keyPress(event: any) {
    if (event.key == 'Enter') {

      var tagToAdd = this.arrowSelectedTag ? this.arrowSelectedTag : event.currentTarget.value.replace(/(^\s+|\s+$)/g, '');
      if (this.arrowSelectedTag) {
        this.arrowSelectedTag = '';
      }
      if (event.currentTarget && tagToAdd) {

        if (!this.includeLower(this.tagModel.tags, tagToAdd)) {
          if (this.isSearchMode) {
            if (this.includeLower(this.tagModel.allTags, tagToAdd)) {
              this.tagModel.tags.push(tagToAdd);
            } else {
              this.toast.showAlertToast("Attention, ce tag n'existe pas!", 3000, true);
            }
          } else {
            this.tagModel.tags.push(tagToAdd);
          }
          event.currentTarget.value = '';
          this.searchIdPereByTag();
        } else {
          var tagElement = document.querySelector(`#tag${tagToAdd}`);
          if (tagElement) {
            tagElement.classList.add('tagHighlight')
            event.currentTarget.value = '';
            setTimeout(() => {
              if (tagElement) {
                tagElement.classList.remove('tagHighlight')
              }
            }, 3000);
          }
        }
      }
      this.toggleSuggest(false);
    } else {
      this.arrowSelectedTag = "";
    }
  }

  public deleteTag(tag: string) {
    var index = this.tagModel.tags.indexOf(tag);
    if (index > -1) {
      this.tagModel.tags.splice(index, 1);
      this.searchIdPereByTag();
    }
  }

  public saveTag(idPere: string) {
    this.tagModel.Mode = 'SAVE_TAG';
    this.tagModel.idPere = idPere;

    this.service.postHttp<TagModel>(`${this.indParam.AppParams.apiUrl}api/tag/`, this.tagModel).subscribe((data: TagModel) => {
      this.dialogservice.showSplash(false);
      this.tagModel.allTags = data.allTags;
      this.filteredTag = data.filteredTag;
      //this.getAllTag();
    });
  }

  private getAllTag() {

    this.tagModel.Mode = 'GET_ALL_TAG';
    this.service.postHttp<TagModel>(`${this.indParam.AppParams.apiUrl}api/tag/`, this.tagModel).subscribe((data: TagModel) => {
      this.dialogservice.showSplash(false);

      this.tagModel.allTags = data.allTags;
      this.filteredTag = this.tagModel.filteredTag;// data.allTags.filter((el) => !this.inclureLower(this.tagModel.tags, el)).sort();

    });
  }

  public addCloseListener() {
    let autoSuggest = this.autoSuggest;
    let renderer = this.renderer;

    $(window).click(function () {
      if (autoSuggest) {
        renderer.addClass(autoSuggest.nativeElement, '-hidden');
      }
      $(window).unbind();
    });

    renderer.listen(this.autoSuggest.nativeElement, 'click', (event) => {
      event.stopPropagation();
    });

    renderer.listen(this.tagTyper.nativeElement, 'click', (event) => {
      event.stopPropagation();
    });
  }

  public autoSuggestChange(event: any) {
    if (event) {
      this.filteredTag = this.tagModel.allTags.filter((el) => !this.includeLower(this.tagModel.tags, el)).filter((el) => el.toLowerCase().startsWith(event.toLowerCase())).sort();
      this.toggleSuggest(true);

    } else {
      this.filteredTag = this.tagModel.allTags.filter((el) => !this.includeLower(this.tagModel.tags, el)).sort();
    }
    this.setAutoSuggestSize();
  }

  public addSuggestTag(event: any) {
    this.tagModel.tags.push(event);
    this.tag = "";
    this.searchIdPereByTag()
    this.toggleSuggest(false);
    this.filteredTag = this.tagModel.allTags.filter((el) => !this.includeLower(this.tagModel.tags, el)).sort();
  }

  private setAutoSuggestSize() {
    let tagLabel: any = this.tagModel.idPere === '' ? document.getElementById(`tagLabel`) : document.getElementById(`tagLabel${this.tagModel.idPere}`);
    if (this.autoSuggest && tagLabel) {
      this.renderer.setStyle(this.autoSuggest.nativeElement, 'width', `${tagLabel.clientWidth}px`);
    }
  }

  private toggleSuggest(toggle: boolean) {
    if (this.autoSuggest) {
      if (toggle) {
        this.renderer.removeClass(this.autoSuggest.nativeElement, '-hidden');
        setTimeout(() => {
          const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          const tagLabelPosY = this.tagTyper.nativeElement.getBoundingClientRect().top;
          const tagLabelHeight = this.tagTyper.nativeElement.offsetHeight;
          const autoSuggestHeight = this.autoSuggest.nativeElement.offsetHeight;
          if (tagLabelPosY + autoSuggestHeight + tagLabelHeight + 10 > screenHeight) {
            this.renderer.addClass(this.autoSuggest.nativeElement, '-top');
          } else {
            this.renderer.removeClass(this.autoSuggest.nativeElement, '-top');
          }
        }, 0)
      } else {
        this.renderer.addClass(this.autoSuggest.nativeElement, '-hidden');
      }
    }
  }

  public getArrowKeys(event: any) {
    if (event) {
      switch (event.code) {
        case 'ArrowDown':
          this.arraowSelect('ArrowDown');
          break;
        case 'ArrowUp':
          this.arraowSelect('ArrowUp');
          break;
      }
    }
  }

  public arraowSelect(arrowCode: string) {
    let posToSelect: number = 0;
    const posSelected: number = this.tagAutoSuggest.toArray().findIndex(el => el.nativeElement.classList.contains('-selected'));

    if (arrowCode == 'ArrowUp') {
      switch (posSelected) {
        case -1:
        case 0: posToSelect = +this.filteredTag.length - 1; break;
        default: posToSelect = posSelected - 1; break;
      }
    } else {
      switch (posSelected) {
        case -1:
        case +this.filteredTag.length - 1: posToSelect = 0; break;
        default: posToSelect = posSelected + 1; break;
      }
    }

    if (posSelected != -1) {
      this.renderer.removeClass(this.tagAutoSuggest.get(posSelected)?.nativeElement, '-selected');
    }
    this.renderer.addClass(this.tagAutoSuggest.get(posToSelect)?.nativeElement, '-selected');
    this.arrowSelectedTag = this.filteredTag[posToSelect];
  }
  public clearArrowSelect() {
    this.tagAutoSuggest.toArray().findIndex(el =>
      this.renderer.removeClass(el.nativeElement, '-selected'))
  }


  public searchIdPereByTag() {
    if (this.isSearchMode) {
      if (this.tagModel.tags.length > 0) {
        this.tagModel.Mode = 'SEARCH_TAG';
        this.service.postHttp<TagModel>(`${this.indParam.AppParams.apiUrl}api/tag/`, this.tagModel).subscribe((data: TagModel) => {
          this.dialogservice.showSplash(false);
          if (data.listIdPere.length == 0) {
            data.listIdPere.push('0')
          }
          this.SearchMode.emit(data.listIdPere);
          this.SearchTagSelect.emit(data.listSelectedTag);
        });
      } else {
        this.SearchMode.emit(new Array<string>());
        this.SearchTagSelect.emit(new Array<Select>());
      }
    }
  }

  public clearSelectedTag(emit: boolean = true) {
    this.tagModel.tags = new Array<string>();
    if (emit) {
      this.SearchMode.emit(new Array<string>());
      this.SearchTagSelect.emit(new Array<Select>());
    }
  }


  private includeLower(source: string[], input: string): boolean {
    return source.some(x => x.toLowerCase() == input.toLowerCase());
  }
}
